import { Flex, Paper, Text } from '@shared/components';
import { WithPermission } from '@shared/permissions';
import { APP_PERMISSIONS } from '@user-management/permissions';
import { UserInvitationButton } from '@user-management/user-invitation';
import { UserManagementList, UserSearchAndFilterForm } from '@user-management/user-management-list';

export default function UserManagementPage() {
  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        width: '100%',
        height: '100dvh',
        bgcolor: theme.palette.grey[50],
      })}
    >
      <Flex
        sx={(theme) => ({
          px: theme.spacing(6),
          py: theme.spacing(8),
          justifyContent: 'space-between',
          alignItems: 'center',
        })}
      >
        <Text variant='h1'>Users</Text>
        <WithPermission requiredPermission={[APP_PERMISSIONS.SETTING.USER.CREATE]}>
          <UserInvitationButton />
        </WithPermission>
      </Flex>
      <Flex sx={{ p: (theme) => theme.spacing(6), flexGrow: 1, width: '100%' }}>
        <Paper
          sx={(theme) => ({
            width: '100%',
            height: '100%',
            borderRadius: theme.shape.rounded(2),
            p: theme.spacing(6),
          })}
        >
          <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(6), height: '100%' }}>
            <UserSearchAndFilterForm />
            <UserManagementList />
          </Flex>
        </Paper>
      </Flex>
    </Flex>
  );
}
